
import InfoPageLayout from "./InfoPageLayout";
import ClipboardButton from "./ClipboardButton"; // <-- Import the new component
import { Handshake } from "lucide-react";

const PartnerWithUs = () => {
  return (
    <InfoPageLayout
      title="Partner With Us"
      subtitle="Let's build the future of scheduling and service integration together."
    >
      <div className="flex flex-col items-center text-center py-16 px-6 bg-gray-900/50 border border-dashed border-white/20 rounded-2xl">
        <Handshake size={48} className="text-green-400 mb-6" />
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
          Let's Build Together.
        </h3>
        <p className="text-gray-400 max-w-xl mb-8">
          While we are finalizing our formal partnership program, we are always
          open to exploring strategic collaborations that bring value to our
          users. We are interested in hearing from service providers, technology
          platforms, and content creators.
        </p>

        {/* ✅ Replace the <a> tag with the new component */}
        <ClipboardButton
          email="partnerships@xenford.com"
          buttonText="Start a Conversation"
        />
      </div>
    </InfoPageLayout>
  );
};

export default PartnerWithUs;
